import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "prompt"
};
const _hoisted_2 = {
  class: "hot-words"
};
const _hoisted_3 = {
  class: "image-size"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "size-font"
};
const _hoisted_6 = {
  class: "model"
};
const _hoisted_7 = {
  class: "model-font"
};
const _hoisted_8 = {
  class: "version"
};
const _hoisted_9 = {
  class: "model"
};
const _hoisted_10 = {
  class: "btns"
};
import { ImageApi } from '@/api/ai/image';
import { AiPlatformEnum, ImageHotWords, MidjourneyModels, MidjourneySizeList, MidjourneyVersions, NijiVersionList } from '@/views/aip/utils/constants';
import { ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    models: {
      type: Array,
      default: () => []
    }
  },
  emits: ['onDrawStart', 'onDrawComplete'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    // 接收父组件传入的模型列表
    const props = __props;
    const emits = __emit; // 定义 emits
    // 定义属性
    const drawIn = ref(false); // 生成中
    const selectHotWord = ref(''); // 选中的热词
    // 表单
    const prompt = ref(''); // 提示词
    const referImageUrl = ref(); // 参考图
    const selectModel = ref('midjourney'); // 选中的模型
    const selectSize = ref('1:1'); // 选中 size
    const selectVersion = ref('6.0'); // 选中的 version
    const versionList = ref(MidjourneyVersions); // version 列表
    /** 选择热词 */
    const handleHotWordClick = async hotWord => {
      // 情况一：取消选中
      if (selectHotWord.value == hotWord) {
        selectHotWord.value = '';
        return;
      }
      // 情况二：选中
      selectHotWord.value = hotWord; // 选中
      prompt.value = hotWord; // 设置提示次
    };
    /** 点击 size 尺寸 */
    const handleSizeClick = async imageSize => {
      selectSize.value = imageSize.key;
    };
    /** 点击 model 模型 */
    const handleModelClick = async model => {
      selectModel.value = model.key;
      if (model.key === 'niji') {
        versionList.value = NijiVersionList; // 默认选择 niji
      } else {
        versionList.value = MidjourneyVersions; // 默认选择 midjourney
      }
      selectVersion.value = versionList.value[0].value;
    };
    /** 图片生成 */
    const handleGenerateImage = async () => {
      // 从 models 中查找匹配的模型
      const matchedModel = props.models.find(item => item.model === selectModel.value && item.platform === AiPlatformEnum.MIDJOURNEY);
      if (!matchedModel) {
        message.error('该模型不可用，请选择其它模型');
        return;
      }
      // 二次确认
      await message.confirm(`确认生成内容?`);
      try {
        // 加载中
        drawIn.value = true;
        // 回调
        emits('onDrawStart', AiPlatformEnum.MIDJOURNEY);
        // 发送请求
        const imageSize = MidjourneySizeList.find(item => selectSize.value === item.key);
        const req = {
          prompt: prompt.value,
          modelId: matchedModel.id,
          width: imageSize.width,
          height: imageSize.height,
          version: selectVersion.value,
          referImageUrl: referImageUrl.value
        };
        await ImageApi.midjourneyImagine(req);
      } finally {
        // 回调
        emits('onDrawComplete', AiPlatformEnum.MIDJOURNEY);
        // 加载结束
        drawIn.value = false;
      }
    };
    /** 填充值 */
    const settingValues = async detail => {
      // 提示词
      prompt.value = detail.prompt;
      // image size
      const imageSize = MidjourneySizeList.find(item => item.key === `${detail.width}:${detail.height}`);
      selectSize.value = imageSize.key;
      // 选中模型
      const model = MidjourneyModels.find(item => item.key === detail.options?.model);
      await handleModelClick(model);
      // 版本
      selectVersion.value = versionList.value.find(item => item.value === detail.options?.version).value;
      // image
      referImageUrl.value = detail.options.referImageUrl;
    };
    /** 暴露组件方法 */
    __expose({
      settingValues
    });
    return (_ctx, _cache) => {
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_space = _resolveComponent("el-space");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_UploadImg = _resolveComponent("UploadImg");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("画面描述")])),
        _: 1
      }), _createVNode(_component_el_text, {
        tag: "p"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("建议使用“形容词+动词+风格”的格式，使用“，”隔开.")])),
        _: 1
      }), _createVNode(_component_el_input, {
        modelValue: prompt.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => prompt.value = $event),
        maxlength: "1024",
        rows: 5,
        class: "w-100% mt-15px",
        "input-style": "border-radius: 7px;",
        placeholder: "例如：童话里的小屋应该是什么样子？",
        "show-word-limit": "",
        type: "textarea"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("随机热词")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "word-list"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ImageHotWords), hotWord => {
          return _openBlock(), _createBlock(_component_el_button, {
            round: "",
            class: "btn",
            type: selectHotWord.value === hotWord ? 'primary' : 'default',
            key: hotWord,
            onClick: $event => handleHotWordClick(hotWord)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(hotWord), 1)]),
            _: 2
          }, 1032, ["type", "onClick"]);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("尺寸")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "size-list"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MidjourneySizeList), imageSize => {
          return _openBlock(), _createElementBlock("div", {
            class: "size-item",
            key: imageSize.key,
            onClick: $event => handleSizeClick(imageSize)
          }, [_createElementVNode("div", {
            class: _normalizeClass(selectSize.value === imageSize.key ? 'size-wrapper selectImageSize' : 'size-wrapper')
          }, [_createElementVNode("div", {
            style: _normalizeStyle(imageSize.style)
          }, null, 4)], 2), _createElementVNode("div", _hoisted_5, _toDisplayString(imageSize.key), 1)], 8, _hoisted_4);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("模型")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "model-list"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MidjourneyModels), model => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(selectModel.value === model.key ? 'modal-item selectModel' : 'modal-item'),
            key: model.key
          }, [_createVNode(_component_el_image, {
            src: model.image,
            fit: "contain",
            onClick: $event => handleModelClick(model)
          }, null, 8, ["src", "onClick"]), _createElementVNode("div", _hoisted_7, _toDisplayString(model.name), 1)], 2);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("版本")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "version-list"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: selectVersion.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectVersion.value = $event),
          class: "version-select !w-350px",
          clearable: "",
          placeholder: "请选择版本"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(versionList.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("参考图")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "model-list"
      }, {
        default: _withCtx(() => [_createVNode(_component_UploadImg, {
          modelValue: referImageUrl.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => referImageUrl.value = $event),
          height: "120px",
          width: "120px"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        round: "",
        disabled: prompt.value.length === 0,
        onClick: handleGenerateImage
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(drawIn.value ? '生成中' : '生成内容'), 1)]),
        _: 1
      }, 8, ["disabled"])])], 64);
    };
  }
});